export default __webpack_public_path__ + "static/media/num-3.a2a58f2c.svg";